import type { AsyncStatus, IAsyncStatus, Team, TeamSelection } from '../../types';
import actions from './actions';
import reducer from './reducer';
import * as selectors from './selectors';

export type TeamsStore = {
  teams: {[key in number]: Team };
  status: AsyncStatus;
  teamUpdatingStatus: IAsyncStatus;
  pendingRemovedProjects: string[];
  pendingRemovedReleaseGroups: number[];
  pendingRemovedUsers: number[];
  teamSelection: TeamSelection;
};

export default { actions, reducer, selectors };
